export default __webpack_public_path__ + "static/media/Mask Group 4@2x.619a97c5.png";